import { toast } from "react-toastify";

export default class _File_ {
  static isImage(file: File) {
    if (!(file instanceof File) && !(file as File).type.startsWith("image/")) {
      toast.error("Invalid file format");
      return false;
    } else {
      return true;
    }
  }
}
